// Import Flickity module
import {
  initFlickity,
  createFlickity,
  whenFlickityReady,
  setupArrowNavigation,
  setupClickHandlers,
  defaultSettings,
} from "../modules/flickity.js";

// Optimized pricing.js - Defer heavy initialization
let spaceStorageOptions, acSpaceStorageOptions, specialStorageOptions;
let itemStorageFlick, spaceStorageFlick;
let pricingInitialized = false;

// Initialize pricing components only when needed
const initPricingComponents = async () => {
  if (pricingInitialized) return Promise.resolve();
  pricingInitialized = true;

  try {
    // Cache DOM elements
    spaceStorageOptions = $("#space-storage")
      .find(".storage-option.space")
      .parent();
    acSpaceStorageOptions = $("#space-storage")
      .find(".storage-option.ac-space")
      .parent();
    specialStorageOptions = $("#space-storage")
      .find(".storage-option.special")
      .parent();

    // Initialize Flickity carousels
    itemStorageFlick = await createFlickity("#item-storage", {
      ...defaultSettings,
      on: {},
    });

    spaceStorageFlick = await createFlickity("#space-storage", {
      ...defaultSettings,
      on: {},
    });

    // Set up event handlers
    setupPricingEventHandlers();

    return Promise.resolve();
  } catch (error) {
    console.error("Error initializing pricing components:", error);
    return Promise.reject(error);
  }
};

// Set up event handlers after initialization
const setupPricingEventHandlers = () => {
  // Setup arrow navigation for both carousels
  setupArrowNavigation(itemStorageFlick, ".item-storage-container");
  setupArrowNavigation(spaceStorageFlick, ".space-storage-container");
};

const modalTypeChanger = (element) => {
  const anchor = $(element).find("a");
  const modalId = anchor.attr("href");
  const size = anchor.data("size");

  if (!modalId || !size) {
    return;
  }

  const body = $(modalId).find(".modal-body .types");

  body.children().hide();
  body.find(`#${size}`).show();

  const footer = $(modalId).find(".modal-footer");
  footer.children().hide();
  footer.find(`#${size}`).show();

  $(modalId).modal("show");
};

const filterSpaceStorage = function (option, transition = true) {
  if (!spaceStorageFlick) return;

  const container = $("#space-storage");
  const cells = spaceStorageFlick.getCellElements();

  if (transition) {
    container.find(".flickity-slider").css("opacity", 0);
  }

  setTimeout(() => {
    spaceStorageFlick.remove(cells);

    if (option === "space-storage") {
      spaceStorageFlick.append(spaceStorageOptions);
    } else if (option === "ac-space-storage") {
      spaceStorageFlick.append(acSpaceStorageOptions);
    }

    spaceStorageFlick.append(specialStorageOptions);
    spaceStorageFlick.select(0, true, true);
    spaceStorageFlick.reposition();

    if (transition) {
      container.find(".flickity-slider").css({
        opacity: 1,
        transition: "opacity 0.3s ease-in-out",
      });
    }
  }, 300);
};

// Initialize pricing when user interacts with pricing section
const initPricingOnInteraction = () => {
  const pricingSection = document.querySelector(
    "#pricing, .pricing-section, #space-storage"
  );
  if (!pricingSection) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // First, ensure Flickity is loaded by initializing the module
          initFlickity()
            .then(() => {
              initPricingComponents().then(() => {
                // Set up Flickity event handlers after initialization
                if (spaceStorageFlick) {
                  spaceStorageFlick.on(
                    "staticClick",
                    function (event, pointer, element, cellIndex) {
                      if (!element) return;
                      modalTypeChanger(element);
                    }
                  );
                }

                if (itemStorageFlick) {
                  itemStorageFlick.on(
                    "staticClick",
                    function (event, pointer, element, cellIndex) {
                      if (!element) return;
                      modalTypeChanger(element);
                    }
                  );
                }

                // Initialize with default filter
                filterSpaceStorage("space-storage", false);

                // Set up storage option handlers
                $("ul#space-storage-options").on(
                  "click",
                  "a.storage-option",
                  function (e) {
                    e.preventDefault();
                    const parent = $(this).parent("li");
                    const currentActive = parent.siblings("li.active");
                    const option = $(this).data("option");

                    if (currentActive.find("a").data("option") !== undefined) {
                      currentActive.removeClass("active");
                      parent.addClass("active");
                      filterSpaceStorage(option);
                    }
                  }
                );

                // Set up modal handlers
                $(
                  "#modal-item-storage, #modal-space-storage, #modal-ac-space-storage"
                )
                  .on("shown.bs.modal", function () {
                    $(this).find(".modal-body").css("opacity", 1);
                  })
                  .on("hide.bs.modal", function () {
                    $(this).find(".modal-body").css("opacity", 0);
                  });

                observer.unobserve(entry.target);
              });
            })
            .catch((error) => {
              console.error("Failed to initialize Flickity:", error);
            });
        }
      });
    },
    { rootMargin: "100px" }
  );

  observer.observe(pricingSection);
};

// Initialize when DOM is ready
$(document).ready(() => {
  initPricingOnInteraction();
});
